// extracted by mini-css-extract-plugin
export default {"textinput":"text_textinput__Ut6nP","text":"text_text__aYupv","errorMessage":"text_errorMessage__dMPKW"};